import * as React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import * as bancas from '../redux/reducers'
import * as filter from '../../../redux-commons/FilterRedux/filterRedux'
import {useDispatch} from 'react-redux'
import {CustomDateInputBancas} from './DateTimePickerBanCas'
import {Checkbox, FormControl, InputAdornment, styled} from '@mui/material'
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark'
import CardMembershipIcon from '@mui/icons-material/CardMembership'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'

type Props = {
  id: string
  options: any[]
  label: string
  defaultValue: any
  objectSelected?: number
  tabName?: string
  formName?: string
  required?: boolean
  validateField?: boolean
  autoCompleteReadOnly?: boolean
  handleValueChanged?: (value: string) => void
}

const AutoCompleteInput = styled(CustomDateInputBancas)(({theme}) => ({
  '& .MuiAutocomplete-input': {
    padding: '12.5px 4px 12.5px 14px !important',
    backgroundColor: 'inherit',
    fontWeight: '500',
  },
  '& .MuiAutocomplete-inputRoot': {
    padding: '1px !important',
    paddingLeft: '14px',
  },
  '& .MuiAutocomplete-endAdornment': {
    top: 'calc(50% - 12px)',
  },
}))

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
const checkedIcon = <CheckBoxIcon fontSize='small' />

const AutoCompleteBasCasMultiple: React.FC<Props> = ({
  id,
  options,
  label,
  autoCompleteReadOnly,
  defaultValue,
  tabName,
  formName,
  objectSelected,
  validateField,
  required,
  handleValueChanged,
}) => {
  const [value, setValue] = React.useState<any>([])
  const [inputValue, setInputValue] = React.useState('')
  const dispatch = useDispatch()

  const handleSaveDataRedux = (value: string) => {
    if (handleValueChanged) handleValueChanged(value)
    if (formName && !formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
        objectSelected: objectSelected ? objectSelected : 0,
      }
      dispatch(bancas.actions.addBancasInfors(data))
    } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        field: id ? id : '',
        value: value,
        filterForm: formName,
      }
      dispatch(filter.actions.updateFilterInfo(data))
    }
  }

  const handleChangeValue = (e: any, value: any) => {
    setValue(value)
    handleSaveDataRedux(JSON.stringify(value))
    // if(handleValueSelected) handleValueSelected(value)
  }

  React.useEffect(() => {
    if (typeof defaultValue == 'string' && defaultValue) {
      setValue(JSON.parse(defaultValue))
    } else setValue(defaultValue ? defaultValue : [])
  }, [defaultValue])

  return (
    <div className='field-wrapper'>
      <FormControl error={validateField} sx={{width: '100%'}}>
        <Autocomplete
          multiple
          value={value}
          id={id}
          options={options}
          disableCloseOnSelect
          getOptionLabel={(option: any) => option?.name || option?.label}
          renderOption={(props, option, {selected}) => (
            <li {...props} key={option.value}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{marginRight: 8}}
                checked={value.find((o: any) => o.value == option.value) != null}
              />
              {option?.name ? option?.name : option?.label}
            </li>
          )}
          onChange={(e, value) => handleChangeValue(e, value)}
          isOptionEqualToValue={(option: any, value: any) =>
            option.value === (value ? value.value : '')
          }
          renderInput={(params) => (
            <AutoCompleteInput {...params} label={label} error={validateField} />
          )}
        />
      </FormControl>
    </div>
  )
}

export {AutoCompleteBasCasMultiple}
